import axios, {AxiosError} from "axios";
import { API_URL } from "../constant";
import { ResetPasswordRequest, RegisterResponse } from "../constant";
  
export async function ResetPassword(requestdata: ResetPasswordRequest): Promise<RegisterResponse> {

    try {
        const response = await axios.post(
          `${API_URL}api/user/resetPassword`,
          requestdata,
        );
    
        if (response.status === 204)
        {
            return { success: true, msg: "Reset Password Success"};
        }
        else if (response.status === 422)
        {
            return { success: false, msg: "Validation Error" };
        }
        else{
            return { success: false, msg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: false, msg: `"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { success: false, msg: "No response received from server" };
        } else {
            return { success: false, msg: `Error:, ${error.message}` };
        }
    }
}